import { render, staticRenderFns } from "./SurveyResultsPreview.vue?vue&type=template&id=1b34f4a3&"
import script from "./SurveyResultsPreview.vue?vue&type=script&lang=ts&"
export * from "./SurveyResultsPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
